var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container",attrs:{"data-testid":"not-found"}},[_c('v-icon',{attrs:{"size":"64px"}},[_vm._v("fas fa-sad-tear")]),_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Page not found!")]),_c('router-link',{attrs:{"to":'/'}},[_vm._v("Go back to homepage")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }